export class ConstanciaDto {
  constructor(data: any | undefined = undefined) {
    if (data != undefined) {

      this.id = data.id;
      this.idTramite = data.idTramite;
      this.tipoConstancia = data.tipoConstancia;
      this.estadoConstancia = data.estadoConstancia;
      this.fechaSolicitud = data.fechaSolicitud;
      this.cuitSolicitante = data.cuitSolicitante;
      this.motivoSolicitud = data.motivoSolicitud;
      this.descripcionMotivoSolicitud = data.descripcionMotivoSolicitud;

      this.esAprobada = data.esAprobada;
      this.fechaAprobacion = data.fechaAprobacion;
      this.aprobadaPor = data.aprobadaPor;
      this.comentarioAprobacion = data.comentarioAprobacion;
      this.fechaVencimiento = data.fechaVencimiento;

      this.esRechazada = data.esRechazada;
      this.fechaRechazo = data.fechaRechazo;
      this.rechazadaPor = data.rechazadaPor;
      this.comentarioRechazo = data.comentarioRechazo;

      this.esAnulada = data.esAnulada;
      this.fechaAnulacion = data.fechaAnulacion;
      this.anuladaPor = data.anuladaPor;
      this.comentarioAnulacion = data.comentarioAnulacion;

      this.idhistorialimpresion = data.idhistorialimpresion;
    }
  }

  public id: number = 0;
  public idTramite: number = 0;
  public tipoConstancia: string = '';
  public estadoConstancia: string = '';
  public fechaSolicitud: string = '';
  public cuitSolicitante: string = '';
  public motivoSolicitud: string = '';
  public descripcionMotivoSolicitud: string = '';

  public esAprobada: string = 'N'; // 'S' o 'N'
  public fechaAprobacion: string = '';
  public aprobadaPor: string = '';
  public comentarioAprobacion: string = '';
  public fechaVencimiento: string = '';

  public esRechazada: string = 'N'; // 'S' o 'N'
  public fechaRechazo: string = '';
  public rechazadaPor: string = '';
  public comentarioRechazo: string = '';

  public esAnulada: string = 'N'; // 'S' o 'N'
  public fechaAnulacion: string = '';
  public anuladaPor: string = '';
  public comentarioAnulacion: string = '';

  public idhistorialimpresion: number = 0;
}
